import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

export const CompanyUsageCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;
  const top = data.items[0]?.requests || 1;

  return (
    <NeuCard
      data-testid="system-companies-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <Building2 className="h-4 w-4 text-primary" /> {t("system.companies", { days: data.days })}
      </p>

      {!data.items.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="system-companies-empty">
          {t("system.noCompanyUsage")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-2" data-testid="system-company-list">
          {data.items.map((c, i) => (
            <li key={`${c.company}-${i}`} className="rounded-2xl bg-background px-3 py-2.5 shadow-neu-sm">
              <div className="flex items-center justify-between gap-3">
                <p className="truncate text-xs font-bold">
                  <span className="me-2 font-mono text-muted-foreground">{i + 1}</span>
                  {c.company}
                  {c.plan ? <span className="ms-2 font-mono text-[10px] text-muted-foreground">{c.plan}</span> : null}
                </p>
                <p className="shrink-0 font-mono text-[11px] font-black text-primary num">
                  {c.requests} · {c.tokens} tk
                </p>
              </div>
              <div className="mt-1.5 h-1.5 rounded-full bg-primary/10">
                <div className="h-1.5 rounded-full bg-primary" style={{ width: `${(c.requests / top) * 100}%` }} />
              </div>
              <p className="mt-1 font-mono text-[10px] text-muted-foreground num">
                {t("system.usageMeta", { users: c.users, ms: c.avg_ms })}
              </p>
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
